import { render, staticRenderFns } from "./HomeAwards.vue?vue&type=template&id=4d79a474&scoped=true&"
import script from "./HomeAwards.vue?vue&type=script&lang=js&"
export * from "./HomeAwards.vue?vue&type=script&lang=js&"
import style0 from "./HomeAwards.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HomeAwards.vue?vue&type=style&index=1&id=4d79a474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d79a474",
  null
  
)

export default component.exports